/* The client card's `⋯`, which KANON v3 draws beside the `‹ ›` walk and which was never built
 * because the roster's own row menu carried the same act. The owner took that menu off on
 * 16 September 2026, so this is where the act lives now.
 *
 * A 32px square rather than the roster's worded pill: this sits in a bar that already holds two
 * icon-sized controls, and a word here would be the third different control shape in one row.
 *
 * Heights and widths are layout rather than design tokens (see stylelint.config.js); every colour,
 * space, radius and type value below is a token. */

.trigger {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  color: var(--text-3);
  background: none;
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition-duration: var(--dur-fast);
  transition-property: color, border-color;
  transition-timing-function: var(--ease);
}

.trigger:hover {
  color: var(--text);
  border-color: var(--text-3);
}

.trigger:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.glyph {
  display: block;
  width: 16px;
  height: 16px;
}
